<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1>展示圖片 300 x 600 像素</h1>
        <p class="my-3">&nbsp;</p>
        <div class="alert bg-light" role="alert">
          <p>• 檔案大小：最大 3MB</p>
          <p>• 檔案限制：JPG、PNG</p>
        </div>
        <!-- PC版圖片顯示 -->

        <div class="PcDevice text-center mt-4">
          <label class="inputFile">
            <div class="pointer imgCorp">
              <img :src="modelSrc4" class="img-thumbnail" width="230px" />
              <div class="cover d-flex justify-content-center align-items-center">
                <div class="grayBackground">選擇圖片</div>
              </div>
            </div>
            <input
              type="file"
              accept=".JPG,.PNG,"
              class="textStyle maxText"
              @change="uploadNewImgPC_Banner($event)"
              style="visibility: hidden"
            />
            <p class="divider"></p>
            <div class="d-flex justify-content-center mt-5">
              <div>
                <p class="align_c"><span class="btn btn-secondary btn-lg mr-2">選擇圖片</span></p>
              </div>
              <div v-if="modelSrc4 !== noImageSrc">
                <p class="align_c">
                  <span class="btn btn-primary btn-lg ml-2" @click.prevent="editBanner4">確認上傳</span>
                </p>
              </div>
            </div>
          </label>
          <!-- 只有在修改後才會出現按鈕 -->
        </div>

        <!-- MB版圖片顯示 -->

        <div class="MbDevice text-center">
          <label class="inputFileMb">
            <p class="my-3">&nbsp;</p>
            <div class="pointer ImgHoverStyle">
              <img :src="modelSrc4" class="img-fluid" width="150px" />
            </div>
            <span name="showName" class="nowrap"></span>
            <input
              type="file"
              accept=".JPG,.PNG"
              class="textStyle maxText"
              @change="uploadImgMb($event)"
              style="visibility: hidden"
            />
            <div class="d-flex justify-content-center">
              <div>
                <p class="align_c"><span class="btn btn-secondary btn-sm mr-1">選擇圖片</span></p>
              </div>
              <div v-if="modelSrc4 !== noImageSrc">
                <p class="align_c">
                  <span class="btn btn-primary btn-sm ml-1" @click.prevent="editBanner4">確認上傳</span>
                </p>
              </div>
            </div>
          </label>
          <p class="my-3">&nbsp;</p>
        </div>

        <!-- 彈跳Modal -->

        <!-- PC裁切彈跳視窗 -->
        <div id="cropImagePop1" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <h3 class="modal-title" style="font-size: 25px">
                  <img class="mb-2 mr-2" src="../../../assets/images/cropImg.png" width="30px" />
                  編輯展示版面圖
                </h3>
                <div type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-9">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber1"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>
                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          <img src="../../../assets/images/RotateL.png" width="16px" alt="" />
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-3">
                          <img src="../../../assets/images/RotateR.png" width="16px" alt="" />
                        </button>
                        <button @click="changeScale(1)" class="btn btn-info ml-3">
                          <i class="fas fa-plus" style="font-size: 10px"></i>
                        </button>
                        <button @click="changeScale(-1)" class="btn btn-info ml-3">
                          <i class="fas fa-minus" style="font-size: 10px"></i>
                        </button>
                      </div>
                      <div>
                        <button @click="refreshCrop" class="btn btn-outline-info ml-5">重設</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="d-flex justify-content-center">
                      <div :style="previewStyle1" class="cropViewFrame">
                        <div :style="previews.div">
                          <img :src="previews.url" :style="previews.img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div>
                  <button type="button" id="cropImageBtn" class="btn btn-lg btn-primary mr-2" @click="OutputPC4()">
                    裁切
                  </button>
                  <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal">關閉</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <p>&middot; 系統將自動調整圖片尺寸。</p>
                <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
              </div>

              <div class="modal-footer">
                <button type="button" id="cropperMb" class="btn btn-sm btn-primary" @click="OutputMb4()">確定</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>
          <p class="my-3">&nbsp;</p>

          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber1"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  import defaultImg from '@/assets/images/default_230x450.jpg'

  export default {
    data() {
      return {
        CSRF_Token: '',
        RegNo: '',
        lang: 'tw',

        previews: {},
        previewStyle1: {},
        modelSrc1: defaultImg,
        modelSrc2: defaultImg,
        modelSrc3: defaultImg,
        modelSrc4: defaultImg,
        noImageSrc: defaultImg,
        OImgSrc: defaultImg,
        showImg: false,

        option: {
          img: '',
          max: 2000, //1
          enlarge: 1, //图片根据截图框输出比例倍数
          mode: 'contain',
          centerBox: false,

          autoCropWidth: 300,
          autoCropHeight: 600,
          full: true,
          high: true,
          size: 1, //1

          original: false, // 上传图片按照原始比例渲染
          autoCrop: true,
          canMoveBox: false,
          canMove: true,
          infoTrue: true,
          fixedBox: true,

          outputType: 'png',
        },

        fixed: true,
        fixedNumber1: [1, 2],
      }
    },
    methods: {
      EnuploadNewImgPC_Banner(e) {
        const vm = this
        let file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('The picture format must be JPG, PNG！')
          return false
        }
        let reader = new FileReader()
        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3
          // console.log(e)
          if (isLt5M) {
            $('#cropImagePop1').modal('show')
            $('#cropImagePop1').on('shown.bs.modal', function () {
              vm.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
              // console.log(vm.option.img)
            })
          } else {
            alert('Maximum file size : 3MB！')
          }
        }
        reader.readAsArrayBuffer(file)
        e.target.value = ''
      },

      uploadNewImgPC_Banner(e) {
        const vm = this
        let file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('上傳檔案類型必須是 JPG,PNG！')
          return false
        }
        let reader = new FileReader()
        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3
          // console.log(e)
          if (isLt5M) {
            $('#cropImagePop1').modal('show')
            $('#cropImagePop1').on('shown.bs.modal', function () {
              vm.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
              // console.log(vm.option.img)
            })
          } else {
            alert('上傳圖片大小請勿超過 3MB！')
          }
        }
        reader.readAsArrayBuffer(file)
        e.target.value = ''
      },

      OutputPC1() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          this.modelSrc1 = data
          // console.log(this.modelSrc1)
          $('#cropImagePop1').modal('hide')
          $('#cropImagePop1').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })
        })
      },

      OutputPC2() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          this.modelSrc2 = data
          // console.log(this.modelSrc2)
          $('#cropImagePop1').modal('hide')
          $('#cropImagePop1').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })
        })
      },

      OutputPC3() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          this.modelSrc3 = data
          // console.log(this.modelSrc1)
          $('#cropImagePop1').modal('hide')
          $('#cropImagePop1').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })
        })
      },

      closefancybox() {
        parent.$.fancybox.close()
      },

      OutputPC4() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          this.modelSrc4 = data
          // console.log(this.modelSrc2)
          $('#cropImagePop1').modal('hide')
          $('#cropImagePop1').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })
        })
      },

      editBanner1() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: vm.modelSrc1,
          BannerImg2: '',
          BannerImg3: '',
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc1 == defaultImg) {
          alert('圖片為必填項目，請重新檢查！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('圖片檔案上傳錯誤！')
            }
          })
        }
      },

      editBanner2() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: vm.modelSrc2,
          BannerImg3: '',
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)

        if (vm.modelSrc2 == defaultImg) {
          alert('圖片為必填項目，請重新檢查！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('圖片檔案上傳錯誤！')
            }
          })
        }
      },

      editBanner3() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: '',
          BannerImg3: vm.modelSrc3,
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc3 == defaultImg) {
          alert('圖片為必填項目，請重新檢查！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('圖片檔案上傳錯誤！')
            }
          })
        }
      },

      editBanner4() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: '',
          BannerImg3: '',
          BannerImg4: vm.modelSrc4,
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc4 == defaultImg) {
          alert('圖片為必填項目，請重新檢查！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('圖片檔案上傳錯誤！')
            }
          })
        }
      },

      EneditBanner1() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: vm.modelSrc1,
          BannerImg2: '',
          BannerImg3: '',
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc1 == defaultImg) {
          alert('Must provide image, please check again！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Image upload failed!')
            } else if (response.data.Code == 500) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            }
          })
        }
      },

      EneditBanner2() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: vm.modelSrc2,
          BannerImg3: '',
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)

        if (vm.modelSrc2 == defaultImg) {
          alert('Must provide image, please check again！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Image upload failed!')
            } else if (response.data.Code == 500) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            }
          })
        }
      },

      EneditBanner3() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: '',
          BannerImg3: vm.modelSrc3,
          BannerImg4: '',
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc3 == defaultImg) {
          alert('Must provide image, please check again！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Image upload failed!')
            } else if (response.data.Code == 500) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            }
          })
        }
      },

      EneditBanner4() {
        const vm = this
        const url = '/apiExhibitors/OnlineExpoBannerUpload/'
        const info = {
          RegNo: vm.RegNo,
          BannerImg1: '',
          BannerImg2: '',
          BannerImg3: '',
          BannerImg4: vm.modelSrc4,
          CSRF: vm.CSRF_Token,
        }
        // console.log(info)
        if (vm.modelSrc4 == defaultImg) {
          alert('Must provide image, please check again！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功上傳圖片展示版位！')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 251) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            } else if (response.data.Code == 252) {
              vm.closefancybox()
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Image upload failed!')
            } else if (response.data.Code == 500) {
              alert('System is busy, please try again later.')
              vm.closefancybox()
              parent.window.location.reload()
            }
          })
        }
      },

      //行動版截圖函式

      uploadImgMb(e) {
        const vm = this
        var file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('上傳檔案類型必須是 JPG,PNG！')
          return false
        }
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3
          if (isLt5M) {
            this.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            vm.showImg = true
            $('#cropperMb').modal('show')
          } else {
            alert('上傳圖片大小請勿超過 3MB！')
          }
        }
        e.target.value = ''
      },

      //行動英文版
      EnuploadImgMb(e) {
        const vm = this
        var file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('The picture format must be JPG, PNG！')
          return false
        }
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3
          if (isLt5M) {
            this.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            vm.showImg = true
            $('#cropperMb').modal('show')
          } else {
            alert('Maximum file size : 3MB！')
          }
        }
        e.target.value = ''
      },

      OutputMb1() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          vm.modelSrc1 = data
        })
        $('#cropperMb').modal('hide')
        vm.showImg = false
      },

      OutputMb2() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          vm.modelSrc2 = data
        })
        $('#cropperMb').modal('hide')
        vm.showImg = false
      },

      OutputMb3() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          vm.modelSrc3 = data
        })
        $('#cropperMb').modal('hide')
        vm.showImg = false
      },

      OutputMb4() {
        const vm = this
        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          vm.modelSrc4 = data
        })
        $('#cropperMb').modal('hide')
        vm.showImg = false
      },

      realTime(data) {
        var previews = data
        var h = 0.4
        var w = 0.2
        this.previewStyle1 = {
          width: previews.w + 'px',
          height: previews.h + 'px',
          overflow: 'hidden',
          margin: '0',
          zoom: h,
        }
        this.previews = data
      },

      rotateLeft() {
        this.$refs.cropper.rotateLeft()
      },
      rotateRight() {
        this.$refs.cropper.rotateRight()
      },

      changeScale(num) {
        num = num || 1
        this.$refs.cropper.changeScale(num)
      },

      refreshCrop() {
        this.$refs.cropper.refresh()
      },

      //重設圖片

      resetImg1() {
        const vm = this
        vm.modelSrc1 = vm.OImgSrc
      },

      resetImg2() {
        const vm = this
        vm.modelSrc2 = vm.OImgSrc
      },

      resetImg3() {
        const vm = this
        vm.modelSrc3 = vm.OImgSrc
      },

      resetImg4() {
        const vm = this
        vm.modelSrc4 = vm.OImgSrc
      },
    },

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //取出url展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得線上展總資料
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.RegNo}`).then((response) => {
        // console.log(response.data)

        if (response.data.Data.Banner1L) {
          vm.modelSrc1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner1L}`
        } else {
          vm.modelSrc1 = defaultImg
        }

        if (response.data.Data.Banner2L) {
          vm.modelSrc2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner2L}`
        } else {
          vm.modelSrc2 = defaultImg
        }

        if (response.data.Data.Banner3L) {
          vm.modelSrc3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner3L}`
        } else {
          vm.modelSrc3 = defaultImg
        }

        if (response.data.Data.Banner4L) {
          vm.modelSrc4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner4L}`
        } else {
          vm.modelSrc4 = defaultImg
        }
      })
    },
  }
</script>

<style lang="scss">
  .imgCorp {
    position: relative;
    transition: all 0.5s;
    cursor: pointer;
    z-index: 9;
  }

  .cover {
    top: 0px;
    width: 100%;
    height: 100%;
    text-align: center;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
  }

  .cover:hover {
    opacity: 1;
    box-shadow: 2px 2px 10px 2px rgb(156, 156, 151);
    transition: all 0.6s;
  }

  .grayBackground {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 23px;
  }

  .btn-sm {
    padding: 0.25rem 1rem;
    font-size: 0.875rem;
    line-height: 2;
    border-radius: 0.2rem;
  }

  .modal-header {
    padding: 0.7rem 0.7rem;
  }

  .inputFileMb {
    width: 70%;
    display: inline-block;
  }
</style>
